import { useEffect, useState } from "react";

const navLinks = [
  { href: "#feed", label: "实时现场" },
  { href: "#timeline", label: "反转档案" },
  { href: "#why", label: "为何可信" },
  { href: "#faq", label: "常见问题" },
  { href: "#subscribe", label: "订阅追瓜" },
];

const tickerNews = [
  "🔴 顶流剧组片酬争议第三轮辟谣发出，评论区风向再度分化",
  "🔥 头部主播选品翻车进入发酵高位，质检细节持续曝光",
  "⚡ 电竞选手转会官宣日迎来大和解，剧本都不敢这么写",
  "📢 老字号品牌道歉后口碑修复，复盘长文发布",
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [tickerPaused, setTickerPaused] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href: string) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="sticky top-0 z-50">
      {/* ticker */}
      <div
        className="overflow-hidden bg-foreground-950 text-background-100"
        onMouseEnter={() => setTickerPaused(true)}
        onMouseLeave={() => setTickerPaused(false)}
      >
        <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 md:px-6 py-1.5">
          <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-primary-500 px-2.5 py-0.5 text-xs font-bold text-background-50">
            <span className="inline-block h-1.5 w-1.5 animate-pulseDot rounded-full bg-background-50" />
            滚动更新
          </span>
          <div className="relative flex-1 overflow-hidden" aria-hidden="true">
            <div
              className="flex w-max items-center gap-10 whitespace-nowrap"
              style={{ animation: tickerPaused ? "none" : "ticker 32s linear infinite" }}
            >
              {[...tickerNews, ...tickerNews].map((n, i) => (
                <span key={i} className="text-xs text-background-200/90">
                  {n}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* nav */}
      <div
        className={`transition-colors duration-200 ${
          scrolled ? "bg-background-50/90 backdrop-blur" : "bg-background-50"
        }`}
      >
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 py-3">
          <a
            href="#top"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="flex items-center gap-2"
            aria-label="爆炸瓜首页"
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-lg" />
            </span>
            <span className="font-heading text-xl font-black tracking-wide text-foreground-950">
              爆炸<span className="text-primary-600">瓜</span>
            </span>
          </a>

          <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
            {navLinks.map((l) => (
              <button
                key={l.href}
                onClick={() => go(l.href)}
                className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-foreground-950"
              >
                {l.label}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="mailto:gossip@baozhagua.example.com"
              className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
            >
              投喂线索
            </a>
            <button
              onClick={() => setOpen(!open)}
              className="flex h-10 w-10 items-center justify-center rounded-md text-xl text-foreground-800 md:hidden"
              aria-label={open ? "关闭菜单" : "打开菜单"}
              aria-expanded={open}
            >
              <i className={open ? "ri-close-line" : "ri-menu-line"} />
            </button>
          </div>
        </div>

        {/* mobile menu */}
        {open && (
          <nav
            className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden"
            aria-label="移动端导航"
          >
            <div className="flex flex-col gap-1">
              {navLinks.map((l) => (
                <button
                  key={l.href}
                  onClick={() => go(l.href)}
                  className="rounded-md px-3 py-2.5 text-left text-base font-medium text-foreground-800 hover:bg-secondary-100"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}